module.exports = __webpack_public_path__ + "static/img/5.f63d287.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/detail/hospital1/5.png
// module id = iW6h
// module chunks = 1